import { render } from "./HalamanDetailKhutbah.vue?vue&type=template&id=45990f32"
import script from "./HalamanDetailKhutbah.vue?vue&type=script&lang=js"
export * from "./HalamanDetailKhutbah.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__